import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PanelModule } from '../../generic-compounds/panel/panel.module';
import { MsgKeyModule } from '../../translate/msg-key.module';
import { HeadlineModule } from '../headline/headline.module';
import { ErrorComponent } from './error.component';
import { ErrorService } from './error.service';

@NgModule({
	imports: [
		HeadlineModule,
		MsgKeyModule,
		CommonModule,
		PanelModule,
	],
	declarations: [
		ErrorComponent,
	],
	exports: [
		ErrorComponent,
	],
})
export class ErrorModule {
	static forRoot(): ModuleWithProviders<any> {
		return {
			ngModule: ErrorModule,
			providers: [ErrorService],
		};
	}
}
